<div class="container">

<div class="commitment-section-container">
  <div class="commitment-image">
    <img src="https://cdn.prod.website-files.com/66e2a677130668674f6e2b5f/66e2bb001e069c27ba03e676_tinypng.com.avif" alt="Commitment" />
  </div>
  <div class="commitment-content">
    <img class="crown-icon" src="https://cdn.prod.website-files.com/66e2a677130668674f6e2b5f/66e2ab61a6e1bd3f18c78e10_icon_chess-crown.svg" alt="Crown Icon" />
    <h2 class="headline">Bist du wirklich bereit 100% zu geben?</h2>
    <ul class="checklist">
      <li>
        <span class="check-icon">✔</span>
        Exklusiver Zugang zu Insider-Strategien
      </li>
      <li>
        <span class="check-icon">✔</span>
        Erhalte Wissen, was dir sonst verborgen bleibt
      </li>
      <li>
        <span class="check-icon">✔</span>
        Nur für High Performer geeignet
      </li>
    </ul>
    <app-apply-button [darkCounter]="true" ></app-apply-button>
  </div>
</div> 
</div>
